import { Middleware, AnyAction} from 'redux';
import { Store as RootState } from '../reducers/rootReducer'

export const accessabilityMiddleware: Middleware<{}, RootState> = store => next => (action: AnyAction) => {
  const result = next(action);

  // Check for the accessibility action
  if (action.type === 'SET_ACCESSIBILITY') {
    const state = store.getState();
    const color = state.accessibility?.siteAccessibilityColour;
    if (color && localStorage.getItem('accessabilitySetting') !== color) {
      localStorage.setItem('accessabilitySetting', color);
    }
  }

  return result;
};